import { useSelector } from "react-redux";
import styled from "styled-components";

const YearSection = ({ minYear, setMinYear, maxYear, setMaxYear, t }) => {
  const language = useSelector((state) => state.language);

  const currentYear = new Date().getFullYear();
  const startYear = 1980;
  const yearOptions = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  );

  return (
    <FilterSection>
      <div className="filter-title">{t.carsFilter.year}</div>
      <YearDropdowns>
        <DropdownWrapper className={language}>
          <select
            value={minYear || ""}
            onChange={(e) => setMinYear(e.target.value)}
            className="year-dropdown"
          >
            <option value="">{t.carsFilter.from}</option>
            {yearOptions.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </DropdownWrapper>
        <DropdownWrapper className={language}>
          <select
            value={maxYear || ""}
            onChange={(e) => setMaxYear(e.target.value)}
            className="year-dropdown"
          >
            <option value="">{t.carsFilter.to}</option>
            {yearOptions.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </DropdownWrapper>
      </YearDropdowns>
    </FilterSection>
  );
};

const FilterSection = styled.div`
  margin-bottom: 15px;

  .filter-title {
    font-size: 18px;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e9ecef;
  }
  @media (max-width: 768px) {
    padding: 10px 15px;
  }
`;

const YearDropdowns = styled.div`
  display: flex;
  gap: 12px;
`;

const DropdownWrapper = styled.div`
  position: relative;
  flex: 1;

  .year-dropdown {
    width: 100%;
    padding: 12px 15px;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    font-size: 14px;
    background-color: white;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;

    &:focus {
      outline: none;
      border-color: #007bff;
    }
  }

  /* Add chevrons using ::before and ::after */
  &::before,
  &::after {
    position: absolute;
    right: 15px;
    font-size: 10px;
    color: #555;
    pointer-events: none;
  }

  &::before {
    content: "▲";
    top: 10px;
  }

  &::after {
    content: "▼";
    bottom: 10px;
  }
  &.ar::before,
  &.ar::after {
    right: auto;
    left: 15px;
  }
`;

export default YearSection;
